import React, { useEffect, useState } from 'react';
import ReportFilters from '../../../components/ReportFilters/ReportFilters';
import defaultFilters from '../../../components/ReportFilters/utils/defaultFilters';
import PrepareTable from '../../../components/PrepareTable';
import TableConfig from './TableConfig';

function SolvedQuestionReport(props) {
  const { preloader } = props;
  const [queryParams, setQueryParams] = useState();
  const preparQueryParams = async (filters) => {
    const columns = TableConfig(); // Колонки для таблиц
    const params = {
      columns: columns.columns,
      filters: filters || defaultFilters(),
      url: '/api/reports/build',
      type: 'solvedQuestionReport',
    };
    setQueryParams(params);
  };

  useEffect(() => {
    preparQueryParams();
  }, []);
  return (queryParams ? (
    <>
      <ReportFilters
        showFilters={{
          main: ['reportRange', 'queues'],
          others: [],
          orders: [],
        }}
        paramsCallback={preparQueryParams}
        type="solvedQuestionReport"
      />
      <PrepareTable
        keys="queue"
        type="QueueTable"
        {...queryParams}
        preloader={preloader}
      />
    </>
  ) : null);
}

export default SolvedQuestionReport;
